import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonCol, IonRow } from '@ionic/angular/standalone';
import { IMAGE_SRC } from '../../shared/shared-constants';
import { CONSTS } from './login-error-banner.constants';

@Component({
  selector: 'app-login-error-banner',
  imports: [IonRow, IonCol],
  templateUrl: './login-error-banner.component.html',
  styleUrl: './login-error-banner.component.scss',
})
export class LoginErrorBannerComponent {
  readonly CONSTS = CONSTS;
  readonly IMAGES = IMAGE_SRC;

  route = inject(ActivatedRoute);

  get errorMessage(): string {
    return this.route.snapshot.queryParamMap.get('errorMessage') || '';
  }

  get isUnauthorizedError(): boolean {
    return !!this.errorMessage;
  }
}
